<template>
  <b-modal id="mod-custinfo" title="Customer Details" ok-only no-close-on-backdrop no-close-on-esc footer-class="mod-foot" @ok="validateCustDetails">

    <!-- TABLE ORDER ONLY -->
    <div v-if="ordertype.id==4">
      <b-row>
        <b-col cols="8">&#127860; <span class="px-2">Table number: </span></b-col>
        <b-col cols="4"><b-form-input v-model="custdets.tablenum" id="table" type="number" placeholder="Enter your table number"></b-form-input></b-col>
      </b-row>
      <b-alert class="mt-2" v-model="tableAlert" variant="primary" dismissible>Please choose a table number</b-alert>
    </div>

    <!-- DELIVERY ONLY -->
    <div v-if="ordertype.id==1">
      <b-row>
        <b-col>&#128757; <span class="px-2">Delivery Address: </span></b-col>
      </b-row>
      <b-row class="my-2">
        <b-col><b-form-input v-model="custdets.cust_addr" type="search" id="cust-addr-search" placeholder="Enter the delivery address"></b-form-input></b-col>
      </b-row>
      <b-alert class="mt-2" v-model="deliveryAlert" variant="primary" dismissible>Address too far away</b-alert>
      <b-alert class="mt-2" v-model="addressAlert" variant="primary" dismissible>Please choose a valid address</b-alert>
    </div>

    <!-- FOR ALL ORDER TYPES EXCEPT TABLE -->
    <div v-if="ordertype.id!=4">
      <b-row class="mt-2">
        <b-alert class="my-2" v-model="nameAlert" variant="primary" dismissible>Please collect a name!</b-alert>
      </b-row>
      <b-row class="mt-2">
        <b-col>
          <b-form-input v-model="custdets.cust_name" placeholder="Customer Name"></b-form-input>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-alert class="my-2" v-model="phoneAlert" variant="primary" dismissible>Please collect a phone number!</b-alert>
      </b-row>
      <b-row class="mt-2">
        <b-alert class="my-2" v-model="tenDigitPhoneAlert" variant="info" dismissible>Not a valid US number.</b-alert>
      </b-row>
      <b-row class="mt-2">
        <b-col cols="5">
          <b-form-select v-model="ccode_selected" :options="ccodes"></b-form-select>
        </b-col>
        <b-col cols="7">
          <b-form-input v-model="custdets.cust_phone" type="tel" placeholder="Cell Number" @change="phoneCheck()"></b-form-input>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col>
          <b-form-checkbox
            v-model="showemail"
            switch
          > Email receipt?</b-form-checkbox>
        </b-col>
      </b-row>
      <b-collapse id="emailInput" v-model="showemail">
        <b-row class="mt-2">
          <b-alert class="my-2" v-model="emailAlert" variant="primary" dismissible>Invalid Email!</b-alert>
        </b-row>
        <b-row class="mt-2">
          <b-col>
            <b-form-input v-model="custdets.cust_email" type="email" placeholder="Email addresss"></b-form-input>
          </b-col>
        </b-row>
      </b-collapse>
    </div>
  </b-modal>
</template>

<script>
// import moment from 'moment'
import ccodejson from '@/json/countrycodes.json'

export default {
  name: 'CustomerDetails',
  props: ['ordertype', 'defaultLocation', 'custNameAlert', 'custdetails'],
  data () {
    return {
      ccode_selected: "1",
      custdets: {
        cust_name: this.custdetails.cust_name,
        cust_phone: this.custdetails.cust_phone,
        cust_email: this.custdetails.cust_email,
        cust_addr: this.custdetails.cust_addr,
        address_confirmed: false,
        tablenum: this.custdetails.tablenum,
      },
      delAddrLatLong: {},
      phoneAlert: false,
      tenDigitPhoneAlert: false,
      emailAlert: false,
      showemail: false,
      deliveryAlert: false,
      addressAlert: false,
      tableAlert: false
    }
  },

  watch: {
    'custdets.cust_name': function() {
      if (this.custdets.cust_name) {
        this.nameAlert = false;
        // this.custNameAlert = false;
      }
    },
  },

  computed: {
    nameAlert: {
      get: function() {
        if (this.custNameAlert==true && !this.custdets.cust_name) {
          return true;
        } else {
          return false;
        }
      },
      set: function(val) {
        return val;
      }
    },
    // showemail: {
    //   get: function() {
    //     if (this.ordertype.id==3) {
    //       return false;
    //     } else {
    //       return true;
    //     }
    //   },
    //   set: function(val) {
    //     return val;
    //   }
    // },

    phone_number: function() {
      return String(this.custdets.cust_phone);
    },

    tenDigitPhone: function() {
      if (this.phone_number.match(/\d/g).length===10) {
        return true;
      } else {
        return false;
      }
    },

    ccodes: function() {
      var codes = [];
      for (const cc of ccodejson) {
       codes.push({"value": cc.value, "text": cc.ccode + ' ' + cc.mcode})
      }
      return codes;
    },

    // Calculate distance in miles from Location Lat/Long to delivery address - Thanks Google Cloud
    haversine_distance: function() {
      const mk1 = {
        "lat": this.defaultLocation.lat,
        "lng": this.defaultLocation.long
      }
      const mk2 = this.delAddrLatLong

      var R = 3958.8; // Radius of the Earth in miles
      var rlat1 = mk1.lat * (Math.PI/180); // Convert degrees to radians
      var rlat2 = mk2.lat * (Math.PI/180); // Convert degrees to radians
      var difflat = rlat2-rlat1; // Radian difference (latitudes)
      var difflon = (mk2.lng-mk1.lng) * (Math.PI/180); // Radian difference (longitudes)

      var d = 2 * R * Math.asin(Math.sqrt(Math.sin(difflat/2)*Math.sin(difflat/2)+Math.cos(rlat1)*Math.cos(rlat2)*Math.sin(difflon/2)*Math.sin(difflon/2)));
      return d;
    }

  },

  methods: {
    emitCustDetails() {
      this.$emit('emit-cust-details', this.custdets, this.phone_number);
    },

    phoneCheck() {
      if (!this.tenDigitPhone) {
        this.tenDigitPhoneAlert = true;
      } else {
        this.tenDigitPhoneAlert = false;
      }
    },

    async initMQPlaceSearch() {
      await (document.querySelector("#cust-addr-search") != null);
      let ps = window.placeSearch({
        key: process.env.VUE_APP_MAPQUEST_KEY,
        container: document.querySelector("#cust-addr-search"),
        collection: [
          'address',
        ]
      });
      ps.on('change', (e) => {
        this.custdets.address_confirmed=true;
        this.delAddrLatLong = e.result.latlng;
        if (this.isDeliveryDistanceWithinRange() == false) {
          this.deliveryAlert = true;
        }
      });
    },

    validateEmail() {
      if (this.showemail) {
        if (!this.custdets.cust_email) {
          return false;
        } else {
          var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return re.test(this.custdets.cust_email);
        }
      } else {
        return true;
      }
    },

    isDeliveryDistanceWithinRange() {
      if (this.haversine_distance > this.defaultLocation.delivery_range && this.ordertype.id == '1') {
        return false;
      } else {
        return true;
      }
    },

    validateCustDetails(bvModalEvt) {
      var valid = true;
      if (this.validateEmail()==false && this.showemail==true && this.ordertype.id != 4) {
        valid = false;
        this.emailAlert = true;
      } else {
        this.emailAlert = false;
      }

      if (!this.custdets.cust_phone && [1,2].includes(this.ordertype.id)) {
        valid = false;
        this.phoneAlert = true;
      } else {
        this.phoneAlert = false;
      }

      if (!this.custdets.cust_name && this.ordertype.id != 4) {
        valid = false;
        this.nameAlert = true;
      } else {
        this.nameAlert = false;
      }

      if (this.ordertype.id == 1 && this.isDeliveryDistanceWithinRange() == false) {
        valid = false;
        this.deliveryAlert = true;
      } else {
        this.deliveryAlert = false;
      }

      // Check for address if delivery
      if (this.ordertype.id == 1 && (this.custdets.address_confirmed==false || this.custdets.cust_addr=='')) {
        valid = false;
        this.addressAlert = true;
      } else {
        this.addressAlert = false;
      }

      if (this.ordertype.id == 4 && this.custdets.tablenum=='') {
        valid = false;
        this.tableAlert = true;
      } else {
        this.tableAlert = false;
      }

      if (valid) {
        this.emitCustDetails();
      } else {
        bvModalEvt.preventDefault();
      }

    },

  },

}
</script>
<style>

.alert {
  margin-left: 1rem;
}


</style>
